import React from 'react'
import { remCss, scssVariables as variables } from 'src/helpers'

const ReplyIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = '20' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={remCss(width)}
      height={remCss(width)}
      viewBox={'0 0 20 20'}
    >
      <path
        d="M8.68044 6.96025V4L3.5 9.18044L8.68044 14.3609V11.334C10.249 11.2107 11.8229 11.4936 13.2504 12.1555C14.6778 12.8174 15.9107 13.8359 16.83 15.1128C16.0944 11.408 13.8712 7.70031 8.68044 6.96025Z"
        fill={fill}/>

    </svg>
  ),
)
ReplyIcon.displayName = 'ReplyIcon';

export default ReplyIcon
